import api from './api';

export const stockExitService = {
  // Récupérer toutes les sorties de stock
  async getStockExits(params = {}) {
    try {
      const response = await api.get('/stock-exits', { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des sorties:', error);
      throw error;
    }
  },

  // Récupérer une sortie par ID
  async getStockExitById(id) {
    try {
      const response = await api.get(`/stock-exits/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de la sortie:', error);
      throw error;
    }
  },

  // Créer une nouvelle sortie de stock
  async createStockExit(data) {
    try {
      const response = await api.post('/stock-exits', data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création de la sortie:', error);
      throw error;
    }
  },

  // Mettre à jour une sortie de stock
  async updateStockExit(id, data) {
    try {
      const response = await api.put(`/stock-exits/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de la sortie:', error);
      throw error;
    }
  },

  // Supprimer une sortie de stock
  async deleteStockExit(id) {
    try {
      const response = await api.delete(`/stock-exits/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de la sortie:', error);
      throw error;
    }
  },

  // Récupérer les statistiques des sorties
  async getStockExitStats() {
    try {
      const response = await api.get('/stock-exits/stats');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des statistiques:', error);
      throw error;
    }
  },

  // Récupérer les sorties par produit
  async getStockExitsByProduct(productId, params = {}) {
    try {
      const response = await api.get(`/stock-exits/product/${productId}`, { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des sorties par produit:', error);
      throw error;
    }
  },

  // Récupérer les sorties par raison
  async getStockExitsByReason(reason, params = {}) {
    try {
      const response = await api.get(`/stock-exits/reason/${reason}`, { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des sorties par raison:', error);
      throw error;
    }
  }
}; 